export enum SECTIONS {
  PREVIEW = 'preview',
  MODULES = 'modules',
  MODULE = 'module',
  WORKSPACE = 'workspace',
  WORKFLOW = 'workflow',
  COURSES = 'courses',
  COURSE = 'course',
  COURSE_NODE = 'node',
  COURSE_PROGRESS = 'progress',
  GROUPS = 'groups',
  SYSTEMS = 'integrations',
  ADMINISTRATORS = 'admins',
  CERTIFICATES = 'certificates',
  VARIABLE = 'variable',
  VARIABLES = 'variables',
  THEME = 'theme',
  LEARNERS = 'learners',
  LEARNER = 'learner',
  INVITES = 'invites',
  INTEGRATIONS = 'integrations',
  DIALOGS = 'dialogs',
  SHARE = 'share',
  EDIT = 'edit',
  SCENE = 'scene',
}
